module.exports = __webpack_public_path__ + "static/img/img_description_of_soldoc2.9123bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_mobile/img_description_of_soldoc2.png
// module id = tf0M
// module chunks = 0